import LegalFormData from "./legal-forms.json";

/**
 * Legal for data is fetched using this URL:
 * > curl https://www.zefix.ch/ZefixREST/api/v1/legalForm.json
 * We decided to get the data once and for all and store it in a JSON file.
 */
type ZefixLegalForm = {
    id: number;
    name: string;
    short: string;
};

type ZefixLang = "de" | "fr" | "it" | "en";

type ZefixLegalFormData = {
    id: number;
    name: {
        de: string;
        fr: string;
        it: string;
        en: string;
    };
    kurzform: {
        de: string;
        fr: string;
        it: string;
        en: string;
    };
};

export const getLegalForm = (id: number, lang: ZefixLang): ZefixLegalForm | null => {
    if (!id) {
        return null;
    }
    const legalForm = (LegalFormData as ZefixLegalFormData[]).find((form) => form.id === id);
    if (!legalForm) {
        return null;
    }
    return {
        id: legalForm.id,
        name: legalForm.name[lang],
        short: legalForm.kurzform[lang],
    };
};

export const getLegalFormName = (id: number, lang: ZefixLang): string => {
    const legalForm = getLegalForm(id, lang);
    return legalForm ? legalForm.name : "";
};
